<template>
  <div :class="$style.container">
    <b-image
      v-if="image"
      :class="$style.image"
      :url="image.file"
      :width="image.width"
      :height="image.height"
    />

    <p v-if="title" :class="$style.title">
      {{title}}
    </p>

    <small
      v-if="description"
      :class="$style.description"
      v-dompurify-html="description"
      data-testid="empty-placeholder-description"
    />

    <slot></slot>
  </div>
</template>

<script>
import imagePayments from '@/assets/images/empty-payments.svg'
import imageGeneric from '@/assets/images/empty-generic.svg'
import imageClients from '@/assets/images/empty-clients.svg'
import imageAppinments from '@/assets/images/empty-appointments.svg'
import imageMemberships from '@/assets/images/empty-memberships.svg'
import imagePackages from '@/assets/images/empty-packages.svg'
import imageState from '@/assets/images/empty-state.svg'
import imageQuickSale from '@/assets/images/empty-quick-sale.svg'
import imageGiftcards from '@/assets/images/empty-giftcards.svg'
import imageRegister from '@/assets/images/empty-register.svg'
import imageWarning from '@/assets/images/warning.svg'
import imageNoResults from '@/assets/images/no-results.svg'
import imageProductsPlaceholder from '@/assets/images/products-placeholder.svg'
import imageNoLocation from '@/assets/images/no-location.svg'
import imageReviews from '@/assets/images/reviews.svg'
import imageBlasts from '@/assets/images/empty-blasts.svg'
import imageMarketNotVerified from '@/assets/images/market-pay-not-verified.svg'
import imageInfo from '@/assets/images/info.svg'

const emptyImages = {
  payments: { file: imagePayments, width: '128px', height: '52px' },
  memberships: { file: imageMemberships, width: '128px', height: '52px' },
  packages: { file: imagePackages, width: '128px', height: '52px' },
  generic: { file: imageGeneric, width: '120px', height: '80px' },
  clients: { file: imageClients, width: '128px', height: '52px' },
  appointments: { file: imageAppinments, width: '128px', height: '52px' },
  state: { file: imageState, width: '128px', height: '52px' },
  'quick-sale': { file: imageQuickSale, width: '128px', height: '52px' },
  giftcards: { file: imageGiftcards, width: '150px', height: '150px' },
  warning: { file: imageWarning, width: '128px', height: '52px' },
  'no-results': { file: imageNoResults, width: '128px', height: '52px' },
  'products-placeholder': { file: imageProductsPlaceholder, width: '128px', height: '75px' },
  'no-location': { file: imageNoLocation, width: '128px', height: '80px' },
  reviews: { file: imageReviews, width: '72px', height: '63px' },
  blasts: { file: imageBlasts, width: '128px', height: '52px' },
  'market-pay-not-verified': { file: imageMarketNotVerified, width: '106px', height: '72px' },
  register: { file: imageRegister, width: '70px', height: '65px' },
  info: { file: imageInfo, width: '70px', height: '70px' },
}

export default {
  props: {
    type: {
      type: String,
      validator: function (value) {
        return Object.keys(emptyImages).includes(value)
      },
    },

    title: {
      type: String,
    },

    description: {
      type: String,
    },

    width: {
      type: String,
      default: '56px',
    },

    height: {
      type: String,
      default: '56px',
    },
  },

  computed: {
    image () {
      return this.type ? emptyImages[this.type] : null
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  padding: 1rem 0;
}

.image {
  margin-bottom: 1rem;
}

.title {
  @include size('16');
  color: $color-gray-02;
  text-align: center;
  margin-bottom: 2px;
}

.description {
  color: $color-gray-08;
  text-align: center;
  @include size('14');
}
</style>
